import { useEffect, useState } from 'react';
import { apiService } from '../services/api';
/** Lädt die Produktliste (der ApiService cached sie für einige Minuten). */
export function useProducts() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        apiService.getProducts().then((res) => {
            if (cancelled)
                return;
            if (res.success)
                setProducts(res.data);
            else
                setError(res.error || 'error');
            setLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, []);
    return { products, loading, error };
}
/** weblink ("vanguard/") → Slug ("vanguard") */
export const productSlug = (p) => (p.weblink || '').replace(/\/$/, '') || String(p.id);
